import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=72739d6a"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=72739d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports